import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SharedModule } from 'app/shared/shared.module';
import { EditUserComponent } from './edit-user.component';
import { RegisterAuthDeviceModalComponent } from './register-auth-device-modal/register-auth-device-modal.component';
import { UserLoginHistoryComponent } from './user-login-history/user-login-history.component';
import { UserChangePasswordModalComponent } from './user-change-password-modal/user-change-password-modal.component';
import { UserEmploymentComponent } from './user-employment/user-employment.component';
import { UserAuditHistoryComponent } from './user-audit-history/user-audit-history.component';

@NgModule({
    declarations: [
        EditUserComponent
        , RegisterAuthDeviceModalComponent
        , UserChangePasswordModalComponent
        , UserLoginHistoryComponent
        , UserAuditHistoryComponent
        , UserEmploymentComponent
    ]
    , imports: [
        RouterModule
        , CommonModule
        , SharedModule
    ]
    , exports: [
        EditUserComponent
        , UserLoginHistoryComponent
    ]
})
export class EditUserModule { }
